module.exports = __webpack_public_path__ + "static/media/cubeio.06531afe.md";